// src/components/ProtectedLayout.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SideNav from './SideNav';

const ProtectedLayout = ({ hideNav = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // If still loading, return null or a loading spinner
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Check if user exists (instead of isAuthenticated)
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      {!hideNav && <SideNav />}
      <main className={`container-fluid ${!hideNav ? 'mt-4' : ''}`}>
        <Outlet />
      </main>
    </>
  );
};

export default ProtectedLayout;